const guide = {
  moreInfo: "מידע נוסף",
  example: "דוגמה",
  askAI: "שאל AI",
  editHint: "קליק ימני לעריכה",
  supports: "תכונות נתמכות",
  colors: "צבעים",
  typography: "טיפוגרפיה",
  text: "טקסט",
} as const;
export default guide;
